// 轻量版 Tawk.to 客服服务（启用）
class TawktoService {
  constructor() {
    this.isLoaded = false;
    this.isVisible = false;
    this.config = {
      propertyId: '68e3360f36ce7e19507da902',
      widgetId: '1j6rombgc',
      customStyle: {
        visibility: {
          desktop: { xOffset: 20, yOffset: 90 },
          mobile: { xOffset: 10, yOffset: 80 }
        }
      }
    };
  }

  init(options = {}) {
    this.config = { ...this.config, ...options };
    if (!this.config.propertyId || !this.config.widgetId) {
      console.warn('Tawk.to 配置缺失：propertyId 或 widgetId');
      return;
    }
    if (this.isLoaded || document.getElementById('tawkto-script')) {
      this._setupAPIHooks();
      return;
    }
    this._loadScript();
  }

  _loadScript() {
    try {
      const script = document.createElement('script');
      script.id = 'tawkto-script';
      script.async = true;
      script.src = `https://embed.tawk.to/${this.config.propertyId}/${this.config.widgetId}`;
      script.charset = 'UTF-8';
      script.setAttribute('crossorigin', '*');

      script.onload = () => {
        this.isLoaded = true;
        this._setupAPIHooks();
      };
      script.onerror = (error) => {
        console.error('Tawk.to 脚本加载失败:', error);
      };

      const firstScript = document.getElementsByTagName('script')[0];
      firstScript.parentNode.insertBefore(script, firstScript);

      window.Tawk_API = window.Tawk_API || {};
      window.Tawk_LoadStart = new Date();
      this._setupAPIHooks();
    } catch (e) {
      console.error('加载 Tawk.to 时发生错误:', e);
    }
  }

  _setupAPIHooks() {
    if (!window.Tawk_API) return;
    window.Tawk_API.onLoad = () => {
      this.isLoaded = true;
      this._adjustPosition();
      this._startMonitor();
      this.isVisible = true;
    };

    window.Tawk_API.onChatMinimized = () => {
      this.isVisible = false;
    };
    window.Tawk_API.onChatMaximized = () => {
      this.isVisible = true;
    };
  }

  _adjustPosition() {
    const isMobile = window.innerWidth <= 768;
    const cfg = isMobile ? this.config.customStyle.visibility.mobile : this.config.customStyle.visibility.desktop;
    const styleId = 'tawkto-position-style';
    const existing = document.getElementById(styleId);
    if (existing) existing.remove();

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = `
      #tawkchat-container, #tawkchat-minified-container, .tawk-min-container {
        bottom: ${cfg.yOffset}px !important;
        right: ${cfg.xOffset}px !important;
        z-index: 999 !important;
      }
    `;
    document.head.appendChild(style);
  }

  _startMonitor() {
    const handler = () => this._adjustPosition();
    window.addEventListener('resize', handler);
    setTimeout(handler, 100);
    setTimeout(handler, 500);
    setTimeout(handler, 1000);
  }

  showWidget() {
    if (window.Tawk_API?.showWidget) window.Tawk_API.showWidget();
  }
  hideWidget() {
    if (window.Tawk_API?.hideWidget) window.Tawk_API.hideWidget();
  }
  maximize() {
    if (window.Tawk_API?.maximize) window.Tawk_API.maximize();
  }
  minimize() {
    if (window.Tawk_API?.minimize) window.Tawk_API.minimize();
  }
  getStatus() {
    if (window.Tawk_API?.getStatus) return window.Tawk_API.getStatus();
    return this.isLoaded ? 'ready' : 'loading';
  }
  destroy() {
    const script = document.getElementById('tawkto-script');
    if (script) script.remove();
    const style = document.getElementById('tawkto-position-style');
    if (style) style.remove();
    window.Tawk_API = null;
    this.isLoaded = false;
    this.isVisible = false;
  }
}

const tawktoService = new TawktoService();
if (typeof window !== 'undefined') {
  window.tawktoService = tawktoService;
}

export default tawktoService;